import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useTenant } from '@/contexts/TenantContext';

export interface Company {
  id: string;
  name: string;
  ico: string | null;
  dic: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
  dataBox: string | null;
  city: string | null;
  street: string | null;
  postalCode: string | null;
  region: string | null;
  country: string | null;
  industry: string | null;
  tags: string[];
  source: string | null;
  createdAt: string;
  _count?: { contacts: number; leads: number };
}

export interface CompaniesResponse {
  data: Company[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CompanyFilters {
  page?: number;
  limit?: number;
  search?: string;
  projectId?: string;
}

export function useCompanies(filters: CompanyFilters = {}) {
  const { currentTenant } = useTenant();

  const params = new URLSearchParams();
  if (filters.page) params.set('page', String(filters.page));
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.search) params.set('search', filters.search);
  if (filters.projectId) params.set('projectId', filters.projectId);

  const queryString = params.toString();
  const path = `/companies${queryString ? `?${queryString}` : ''}`;

  return useQuery({
    queryKey: ['companies', filters, currentTenant?.id],
    queryFn: () => api.get<CompaniesResponse>(path),
    enabled: !!currentTenant,
  });
}
